import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
    Contact,
    TrainingSessionCompany,
    TrainingSessionContact,
} from '../../../../../../../_services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'registration-contact-edition',
    templateUrl: 'contact-edition.component.html',
    styleUrls: [
        '../../../registration.component.scss',
        '../../../../../../_shared/label/label.component.scss',
    ],
})
export class SessionContactEditionComponent implements OnInit {
    @Input() contacts: Contact[];
    @Input() company: TrainingSessionCompany;
    @Input() contact: TrainingSessionContact;
    @Output() tsContact: EventEmitter<TrainingSessionContact> =
        new EventEmitter<TrainingSessionContact>();

    newContact: TrainingSessionContact;

    contactFormString: string;
    createdContact: Contact;
    private addContactModal;

    constructor(private modalService: NgbModal) {}

    ngOnInit(): void {}

    formatContact({ firstName, lastName, email }) {
        return `${firstName} ${lastName} (${email})`;
    }

    onContactSelected(contact) {
        this.displayNewContact(contact);
    }

    displayNewContact(contact: Contact) {
        this.contact = {
            id: contact.id,
            students: this.contact.students,
            firstName: contact.firstName,
            lastName: contact.lastName,
            email: contact.email,
            emailingMode: 'CONTACT_AND_STUDENTS',
        };
        this.tsContact.emit(this.contact);
    }

    showModalAddContact(addContactModal) {
        event.stopPropagation();

        this.createdContact = {
            deleted: false,
            version: 1,
            type: 'CONTACT',
            title: '',
            firstName: '',
            lastName: '',
            email: '',
            job: '',
            phone: '',
            company: null,
            initialized: true,
            emailingMode: 'CONTACT_AND_STUDENTS',
        };

        this.addContactModal = this.modalService.open(addContactModal, {
            windowClass: 'addContactModal',
        });
    }

    getCreatedContact(event: any) {
        this.contacts.push(event);

        this.displayNewContact(event);
        this.closeCreateContactModal();
    }

    closeCreateContactModal() {
        this.addContactModal.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/registration/registration-company/registration-contact/contact-edition/contact-edition.component.ts